/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import * as Styles from './Dashboard.style';
import Alerts from 'components/support/dashboard/alerts/Alerts';
import { useMutation, useQuery } from 'react-query';
import { MUTE_ALERT, LOGIN_TO_PORTAL, ADD_STAFF_NOTES, ADMIN_ACTIONS } from 'components/support/queries';
import useSound from 'use-sound';
import NotificationSound from 'assets/sound/sound1.wav';
import StaffNotes from 'components/support/dashboard/staff-notes/StaffNotes';
import OrderCreditApprove from 'components/support/dashboard/order-credit-approve/OrderCreditApprove';
import StaffQuestions from 'components/support/dashboard/staff-question/StaffQuestions';
import ClientsTickets from 'components/support/dashboard/client-tickets/ClientsTickets';
import moment from 'moment';
import { CustomHook } from 'utils/custom-hook';

const Dashboard = () => {
  const { mutationProps } = CustomHook();
  const [play] = useSound(NotificationSound);
  const [isOpenAlert, setIsOpenAlert] = useState(true);
  const [isOpenStaffNotes, setIsOpenStaffNotes] = useState(true);
  const [alertId, setAlertId] = useState(0);
  const [isLoadingMuteAlert, setIsloadingMuteAlert] = useState(false);
  const [isOpenStaffModal, setIsStaffModal] = useState(false);
  const closeStaffNoteModal = () => setIsStaffModal(!isOpenStaffModal);
  const { mutate: muteAlert } = useMutation(MUTE_ALERT);
  const {
    data: openAlerts,
    isLoading: openLoading,
    isFetching: openFetching,
    refetch: openAlertsRefetch,
  } = useQuery('/admin/alerts/open');
  const {
    data: closedAlerts,
    isFetching: closedFetching,
    isLoading: closedLoading,
    refetch: colsedAlertsRefetch,
  } = useQuery('/admin/alerts/closed');
  const { data: getTickets, refetch: getTicketsRefetch, isFetching: loadingTickets } = useQuery('/admin/tickets');
  const { data: getSubStatus } = useQuery('/admin/tickets/substatus/definitions');
  const { data: getDeparment } = useQuery('/admin/tickets/department/definitions');
  const { mutate: loginToPortal, isLoading: loadingUrl } = useMutation(LOGIN_TO_PORTAL);
  const { mutate: addStaffNotes, isLoading: addStaffNotesLoading } = useMutation(ADD_STAFF_NOTES);
  const {
    data: openStaffNotes,
    isLoading: openStaffLoading,
    isFetching: openStaffFetching,
    refetch: openStaffRefetch,
  } = useQuery('/admin/staff/notes/open');
  const {
    data: closedStaffNotes,
    isFetching: closedStaffFetching,
    isLoading: closedStaffLoading,
    refetch: colsedStaffRefetch,
  } = useQuery('/admin/staff/notes/closed');
  const { mutate: closeStaffNotes, isLoading: loadingCloseStaff } = useMutation(ADMIN_ACTIONS);

  const handleCloaseStaffNotes = async (id) => {
    await closeStaffNotes(
      {
        action: 'closestaffnote',
        id: id,
      },
      mutationProps(() => {}, {
        onSuccess: async () => {
          await openStaffRefetch();
          await colsedStaffRefetch();
        },
      }),
    );
  };

  const handleAddStaffNotes = async (summarytext, date, schDate) => {
    await addStaffNotes(
      {
        ticket_reference: '',
        note: btoa(summarytext),
        when: date,
        scheduled_date: date === 'later' ? moment(schDate).format('YYYY-MM-DD HH:mm:ss') : '',
      },
      mutationProps(() => {}, {
        onSuccess: async () => {
          closeStaffNoteModal();
          await openStaffRefetch();
        },
      }),
    );
  };

  const handlePortalLogin = async (portal, user) => {
    await loginToPortal(
      {
        portal: portal,
        user: user,
      },
      {
        onSuccess: (e) => {
          window.open(e.redirect_url, '_blank');
        },
      },
    );
  };

  const handleChangeAlert = (val) => {
    setIsOpenAlert(val);
    if (val) {
      openAlertsRefetch();
    } else {
      colsedAlertsRefetch();
    }
  };

  const handleStaffNotes = (val) => {
    setIsOpenStaffNotes(val);
    if (val) {
      openStaffRefetch();
    } else {
      colsedStaffRefetch();
    }
  };

  const onMutedAlert = async (id, isMute) => {
    setIsloadingMuteAlert(true);
    setAlertId(id);
    await muteAlert(
      { alertId: id, muted: isMute === '0' ? '1' : '0' },
      {
        onSuccess: async () => {
          await openAlertsRefetch();
          setIsloadingMuteAlert(false);
        },
        onError: () => {
          setIsloadingMuteAlert(false);
        },
      },
    );
  };

  useEffect(() => {
    setInterval(() => getTicketsRefetch(), 30 * 1000);
    const interval = setInterval(() => {
      if (isOpenAlert) {
        play();
        openAlertsRefetch();
      } else {
        colsedAlertsRefetch();
      }
    }, 30 * 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Styles.BgLogin>
      <div>
        <Styles.TopWindows>
          <Styles.First>
            <Alerts
              isOpenAlert={isOpenAlert}
              openAlerts={openAlerts}
              closedAlerts={closedAlerts}
              loading={openLoading || closedLoading}
              isFetching={openFetching || closedFetching}
              handleChangeAlert={(val) => handleChangeAlert(val)}
              openAlertsRefetch={openAlertsRefetch}
              onMutedAlert={(alertId, isMute) => onMutedAlert(alertId, isMute)}
              loadingMuteAlert={isLoadingMuteAlert}
              alertId={alertId}
            />
            <StaffNotes
              handleStaffNotes={(val) => handleStaffNotes(val)}
              openStaffNotes={openStaffNotes}
              closedStaffNotes={closedStaffNotes}
              loading={openStaffLoading || closedStaffLoading}
              isFetching={openStaffFetching || closedStaffFetching}
              isOpenStaffNotes={isOpenStaffNotes}
              addStaffNotesLoading={addStaffNotesLoading}
              closeStaffNoteModal={closeStaffNoteModal}
              isOpenStaffModal={isOpenStaffModal}
              handleAddStaffNotes={handleAddStaffNotes}
              handleCloaseStaffNotes={handleCloaseStaffNotes}
              loadingCloseStaff={loadingCloseStaff}
            />
            <OrderCreditApprove />
          </Styles.First>
          <ClientsTickets
            getDeparment={getDeparment}
            getTickets={getTickets}
            loadingTickets={loadingTickets}
            getSubStatus={getSubStatus}
            handlePortalLogin={handlePortalLogin}
            loadingUrl={loadingUrl}
          />
        </Styles.TopWindows>
        <Styles.BottomWindows>
          <StaffQuestions />
        </Styles.BottomWindows>
      </div>
    </Styles.BgLogin>
  );
};

export default Dashboard;
